export default __webpack_public_path__ + "static/media/folder-heart.212bc844.svg";